import * as React from "react";
import type { SVGProps } from "react";
const SvgBell01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m3.119 16.867-.816-.579zm1.308-3.976-1-.012v.012zm.028-2.404 1 .011v-.011zm16.433 6.399.827-.562zM19.63 12.89l-1-.012v.012zm.028-2.285 1 .012v-.012zM9 20.6a1 1 0 0 0 0 2v-2m6 2a1 1 0 1 0 0-2v2M3.119 16.867l.816.578c.75-1.058 1.492-2.634 1.492-4.554h-2c0 1.398-.543 2.577-1.124 3.397zm1.308-3.976 1 .011.028-2.404-1-.011-1-.012-.028 2.404zm16.461 3.995.827-.562c-.557-.82-1.086-2.013-1.086-3.433h-2c0 1.92.712 3.498 1.432 4.557zM19.63 12.89l1 .012.027-2.285-1-.012-1-.012-.027 2.285zm.028-2.285h1C20.657 5.588 16.845 1.4 12 1.4v2c3.612 0 6.657 3.16 6.657 7.206zM20.43 18v1c.797 0 1.262-.593 1.438-1.036.18-.453.217-1.097-.153-1.64l-.827.562-.827.562a.33.33 0 0 1-.06-.164.13.13 0 0 1 .008-.058.3.3 0 0 1 .085-.108.53.53 0 0 1 .336-.118zM4.455 10.487h1C5.455 6.507 8.449 3.4 12 3.4v-2c-4.784 0-8.545 4.135-8.545 9.087zM3.57 18v-1c.154 0 .273.063.34.12.06.052.078.095.082.106a.1.1 0 0 1 .007.053.33.33 0 0 1-.065.166l-.816-.578-.816-.579c-.387.546-.352 1.2-.177 1.657.172.444.635 1.055 1.445 1.055zm16.859 0v-1H3.571v2H20.43zM9 21.6v1h6v-2H9z"
    />
  </svg>
);
export default SvgBell01;
